module.exports = __webpack_public_path__ + "static/media/close_black.2c3e1a90.svg";